export * from './consolidated.component';

